import { render } from "./RecentVisitWarningModal.vue?vue&type=template&id=4d0aa240&scoped=true"
import script from "./RecentVisitWarningModal.vue?vue&type=script&lang=js"
export * from "./RecentVisitWarningModal.vue?vue&type=script&lang=js"

import "./RecentVisitWarningModal.vue?vue&type=style&index=0&id=4d0aa240&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0aa240"]])

export default __exports__